<template>
  <div class="c-app flex-row align-items-center">
    <div v-if="submitted" class="loader">
      <CSpinner
        style="width:3rem;height:3rem;"
        color="primary"
        grow
      />
    </div>
    
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Reset Password</h1>
                  <p class="text-muted">Please type your registered email to reset password</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="username email"
                    name="email"
                    v-model="form.email"
                    v-validate="{required: true, min: 3, email: true}"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <div v-if="errors" class="error_msg">
                    {{errors.first('email')}}
                  </div>
                  <CInput
                      placeholder="Password"
                      type="password"
                      name="password"
                      v-model="form.password"
                      v-validate="{required: true, min: 8}"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <div v-if="errors" class="error_msg">
                    {{errors.first('password')}}
                  </div>
                  <CInput
                      placeholder="Confirm Password"
                      type="password"
                      name="password_confirmation"
                      v-model="form.password_confirmation"
                      v-validate="{required: true, min: 8}"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <div v-if="errors" class="error_msg">
                    {{errors.first('password_confirmation')}}
                  </div>
                  <CRow class="mt-3">
                    <CCol col="12" class="text-center">
                      <CButton color="primary" class="px-4" @click="Login">Reset Password</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {handleResponseException, handleUserLoginLogOutAction} from "@/helpers/Helpers";
import {noTokenRequest} from "@/config/httpCommon"
import Store from "../../store";

export default {
  name: 'ResetPassword',
  data(){
    return{
      form:{
        email: '',
        password: '',
        password_confirmation:'',
      },
      submitted: false,
    }
  },
  methods: {
    async Login(){
      let valid = await this.$validator.validate();
      if(valid){
        if(this.form.password === this.form.password_confirmation){
          this.submitted = true;
          let form_data = {
            email: this.form.email,
            password: this.form.password,
            password_confirmation: this.form.password_confirmation,
            token: this.$route.query.token,
          }
          await noTokenRequest.post("reset-password", form_data).then(async successResponse => {
            let response_data = successResponse.data;
            if(response_data.success) {
              this.showToast('Password Changed Successfully', 'SUCCESS');
              this.$router.push('login')
            } else {
              this.showToast('Something went wrong', 'ERROR');
            }
            this.submitted = false;
          }).catch(error => {
            this.submitted = false;
            this.showToast('Something went wrong', 'ERROR');
          });
        }
        else{
          this.showToast('Password does not match', 'ERROR');
        }

      }
    }
  }
}
</script>
<style scoped>
    .form-group {
      margin: 1rem 0 0 0;
    }
    .input-group-prepend {
      background-color: transparent;
      padding: 0;
      color: #fff;
      padding-top: 0;
    }
</style>
